import { TableColumnHeaderLayout } from '../TableColumnHeaderLayout';

type Props = { title: string };

export const TableColumnHeader: React.FC<Props> = ({ title }) => {
  return <TableColumnHeaderLayout title={title} />;
};
